export const microbiologyProducts = {
  'prd-mindray-fa-n-series': {
    key: 'faN',
    primaryMedia: '/media/source/images/FA-N-series-1.png',
    gallery: [
      '/media/source/images/FA-N20-1.png',
      '/media/source/images/FA-N60.png',
      '/media/source/images/FA-N120-2.png',
      '/media/source/images/FA-N480-1.png',
      '/media/source/images/bottiglie-nuove-1.png',
    ],
  },
  'prd-mindray-af-300': {
    key: 'af300',
    primaryMedia: '/media/source/images/sistema-AF-1.png',
    gallery: [
      '/media/source/images/piastre_kit.png',
      '/media/source/images/AF-300.png',
      '/media/source/images/AP-100.png',
    ],
  },
} as const

export type MicrobiologyProductId = keyof typeof microbiologyProducts
export type MicrobiologyProductKey = (typeof microbiologyProducts)[MicrobiologyProductId]['key']

export function isMicrobiologyProductId(id: string): id is MicrobiologyProductId {
  return id in microbiologyProducts
}
